import { Application } from "@hotwired/stimulus";
import PlusLandingTopbar from "../../../../js/controllers/plus_landing_topbar_controller";
import PlusLandingColumns from "../../../../js/controllers/plus_landing_columns_controller";
import PlusLandingTabs from "../../../../js/controllers/plus_landing_tabs_controller";

import "../../../../js/base";
import "../../../../js/organism/carousel/carousel-component";

window.Stimulus = Application.start();
window.Stimulus.register("plus-landing-topbar", PlusLandingTopbar);
window.Stimulus.register("plus-landing-columns", PlusLandingColumns);
window.Stimulus.register("plus-landing-tabs", PlusLandingTabs);
